module.exports = __webpack_public_path__ + "img/60.daca53a2.png";